import React, { useEffect, useState } from "react";
import StepDua from "../FormRealokasi/StepDua";
import StepTiga from "../FormRealokasi/StepTiga";
import StepEmpat from "../FormRealokasi/StepEmpat";
import useAxios from "../../../Utils/useAxios";
import {
  formatRP,
  getDateToday,
  getUser,
} from "../../../Utils/externalFunctions";
import { convertRPInputToIntValue } from "../../../Utils/otherFunctions";
import { useParams } from "react-router-dom";
import { FORM_TYPE } from "../../../Constant/FormType";
import FormStepContainer from "../../../Layout/Containers/FormStepContainer";
import {
  getAnggaranDipakaiRealokasi,
  getAnggaranDipakaiRealokasiAnggaran,
  getJenisPembayaran,
  getRealokasiById,
  getRencImp,
  getUMO,
  getUnitKerja,
} from "../services";

const EditRealokasi = () => {
  const axiosInstance = useAxios();
  const { formId } = useParams();

  const [data, setData] = useState({
    umoList: [],
    unitKerja: [],
    jenisPembayaran: [],
    rencImp: [],
  });
  const [anggaranRencimpRealokasi, setAnggaranRencimpRealokasi] = useState([]);

  const [step, setStep] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedRencImp, setSelectedRencImp] = useState(null);
  const [formattedNilai, setFormattedNilai] = useState("0");
  const [anggaranRencimpFormattedNilai, setAnggaranRencimpFormattedNilai] =
    useState([]);

  const [formRealokasi, setFormRealokasi] = useState({
    id_realokasi: "",
    kd_anggaran_bulanan_unit_kerja: "",
    kd_rencana_implementasi: "",
    unit_kerja: "",
    tanggal_realokasi: getDateToday("original"),
    nilai_anggaran: "",
    keterangan: "",
    diajukan_oleh: getUser(),
    is_target: "",
    alasan: "",
    kd_akun: "",
    nm_akun: "",
    kd_keg: "",
    nm_keg: "",
    kode_jk: "",
    nama_jk: "",
  });

  const isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      const { data: umoData } = await getUMO(axiosInstance);
      setData((prev) => ({ ...prev, umoList: umoData }));

      const { data: unitKerjaData } = await getUnitKerja(axiosInstance);
      setData((prev) => ({ ...prev, unitKerja: unitKerjaData }));

      const { data: jenisPembayaranData } = await getJenisPembayaran(
        axiosInstance
      );
      setData((prev) => ({ ...prev, jenisPembayaran: jenisPembayaranData }));

      const { data: rencImpData } = await getRencImp(axiosInstance);
      setData((prev) => ({ ...prev, rencImp: rencImpData }));

      getFormId();

      getAnggaranRencimpRealokasi();
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [anggaranRencimpRealokasi]);

  useEffect(() => {
    setAnggaranRencimpFormattedNilai(() => {
      return data.rencImp.map((item) => {
        return {
          pk: item.pk,
          formatted_nilai: "0",
          isValid: true,
        };
      });
    });
  }, [data.rencImp]);

  const getFormId = async () => {
    try {
      const responseForm = await getRealokasiById(axiosInstance, formId);
      const responseRencimp = await getRencImp(axiosInstance);
      const responseAnggaranRealokasi = await getAnggaranDipakaiRealokasi(
        axiosInstance
      );
      if (responseForm.status === 200) {
        setFormRealokasi(responseForm.data);

        const numericValue = convertRPInputToIntValue(
          responseForm.data.nilai_anggaran
        );
        setFormattedNilai(formatRP(numericValue));

        if (responseRencimp.status === 200) {
          setSelectedRencImp(
            responseRencimp.data.find((item) => {
              return (
                item.pk === parseInt(responseForm.data.kd_rencana_implementasi)
              );
            })
          );
        }

        if (responseAnggaranRealokasi.status === 200) {
          setAnggaranRencimpFormattedNilai((prev) =>
            prev.map((item) => {
              const selectedAnggaranRencimp =
                responseAnggaranRealokasi.data.find(
                  (anggaran) =>
                    anggaran.rencana_imp === item.pk &&
                    anggaran.realokasi === responseForm.data.id
                );
              return selectedAnggaranRencimp
                ? {
                    ...item,
                    formatted_nilai: formatRP(
                      convertRPInputToIntValue(
                        selectedAnggaranRencimp.anggaran_digunakan
                      )
                    ),
                  }
                : item;
            })
          );
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getAnggaranRencimpRealokasi = async () => {
    try {
      await getRealokasiById(axiosInstance, formId).then((realokasi) => {
        getAnggaranDipakaiRealokasiAnggaran(
          axiosInstance,
          realokasi.data.id_realokasi
        ).then((res) => {
          setAnggaranRencimpRealokasi(() => {
            return res.data.map((data) => {
              return {
                id_anggaran_dipakai_realokasi:
                  data.id_anggaran_dipakai_realokasi,
                rencana_imp: data.rencana_imp,
                anggaran_digunakan: convertRPInputToIntValue(
                  data.anggaran_digunakan
                ),
              };
            });
          });
        });
      });
    } catch (e) {
      console.error(e);
    }
  };

  const calculateTotal = () => {
    let sum = 0;
    anggaranRencimpRealokasi.forEach((item) => {
      const value = parseFloat(item.anggaran_digunakan);
      if (!isNaN(value)) {
        sum += value;
      }
    });
    setTotal(sum);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "nilai_anggaran") {
      const numericValue = convertRPInputToIntValue(value);

      setFormRealokasi((prev) => ({
        ...prev,
        nilai_anggaran: numericValue,
      }));

      setFormattedNilai(formatRP(numericValue));
    } else {
      setFormRealokasi((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleCheckbox = (e) => {
    const { id, checked } = e.target;
    setFormRealokasi((prevForm) => ({
      ...prevForm,
      id_um_list: checked
        ? [...prevForm.id_um_list, id]
        : prevForm.id_um_list.filter((item) => item !== id),
    }));
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    const fieldType = e.target.getAttribute("data-field-type");

    const numericValue = convertRPInputToIntValue(value);

    setAnggaranRencimpFormattedNilai((prev) =>
      prev.map((item) =>
        item.pk === Number(id)
          ? { ...item, formatted_nilai: formatRP(numericValue) }
          : item
      )
    );

    if (numericValue === 0) {
      setAnggaranRencimpRealokasi((prev) =>
        prev.filter((item) => item.rencana_imp !== Number(id))
      );
    } else {
      setAnggaranRencimpRealokasi((prev) => {
        const existingObject = prev.find(
          (item) => item.rencana_imp === Number(id)
        );
        if (existingObject) {
          return prev.map((item) =>
            item.rencana_imp === Number(id)
              ? { ...item, [fieldType]: numericValue }
              : item
          );
        } else {
          const newObject = {
            id_anggaran_dipakai_realokasi: formRealokasi.id_realokasi,
            rencana_imp: Number(id),
            [fieldType]: numericValue,
          };
          return [...prev, newObject];
        }
      });
    }
  };

  const handleFileChange = (e) => {
    const doc = e.target.files[0];
    setFormRealokasi((prev) => ({
      ...prev,
      doc: doc,
    }));
  };

  const nextStep = (e) => {
    setStep(step + 1);
  };

  const prevStep = (e) => {
    setStep(step - 1);
  };

  return (
    <FormStepContainer step={step}>
      {" "}
      <StepDua
        nextStep={nextStep}
        prevStep={prevStep}
        handleChange={handleChange}
        handleFileChange={handleFileChange}
        handleCheckbox={handleCheckbox}
        umoList={data.umoList}
        formRealokasi={formRealokasi}
        setFormRealokasi={setFormRealokasi}
        unitKerja={data.unitKerja}
        jenisPembayaran={data.jenisPembayaran}
        selectedRencImp={selectedRencImp}
        formattedNilai={formattedNilai}
        formType={FORM_TYPE.Edit}
      />
      <StepTiga
        nextStep={nextStep}
        prevStep={prevStep}
        handleInputChange={handleInputChange}
        total={total}
        rencImp={data.rencImp}
        anggaranRencimpRealokasi={anggaranRencimpRealokasi}
        anggaranRencimpFormattedNilai={anggaranRencimpFormattedNilai}
        setAnggaranRencimpFormattedNilai={setAnggaranRencimpFormattedNilai}
        formRealokasi={formRealokasi}
        unitKerja={data.unitKerja}
        jenisPembayaran={data.jenisPembayaran}
      />
      <StepEmpat
        nextStep={nextStep}
        prevStep={prevStep}
        total={total}
        formRealokasi={formRealokasi}
        rencImp={data.rencImp}
        anggaranRencimpRealokasi={anggaranRencimpRealokasi}
        unitKerja={data.unitKerja}
        jenisPembayaran={data.jenisPembayaran}
        selectedRencImp={selectedRencImp}
        formType={FORM_TYPE.Edit}
      />
    </FormStepContainer>
  );
};

export default EditRealokasi;
